import React, { useState } from 'react';
import Container from '@mui/material/Container';

import {
  DesktopFiltersGroup,
  DesktopFiltersItemWrapper,
  DurationSelect,
  FocusSelect,
  LevelSelect,
  StyleSelect,
  TeachersSelect,
} from '../FinderPage';

export const DesktopFilters: React.FC<{ hidden?: boolean }> = ({ hidden = false }) => {
  const [refEl, setRefEl] = useState<HTMLElement | null>();
  const style = hidden ? { display: 'none' } : {};

  return (
    <Container maxWidth="xl" style={style}>
      <DesktopFiltersGroup ref={setRefEl}>
        <DesktopFiltersItemWrapper>
          <StyleSelect containerRef={refEl} />
        </DesktopFiltersItemWrapper>
        <DesktopFiltersItemWrapper>
          <DurationSelect containerRef={refEl} />
        </DesktopFiltersItemWrapper>
        <DesktopFiltersItemWrapper>
          <TeachersSelect containerRef={refEl} />
        </DesktopFiltersItemWrapper>
        <DesktopFiltersItemWrapper>
          <LevelSelect containerRef={refEl} />
        </DesktopFiltersItemWrapper>
        <DesktopFiltersItemWrapper>
          <FocusSelect containerRef={refEl} />
        </DesktopFiltersItemWrapper>
      </DesktopFiltersGroup>
    </Container>
  );
};
